var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4029_1689",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.05719e-05H23.9999V24H0V7.05719e-05Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4029_1689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5312 11.9999C23.5312 18.3684 18.3685 23.5311 12 23.5311C5.63145 23.5311 0.46875 18.3684 0.46875 11.9999C0.46875 5.6314 5.63145 0.468697 12 0.468697C18.3685 0.468697 23.5312 5.6314 23.5312 11.9999Z",
    fill: "url(#paint0_linear_4029_1689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9375 12C18.9375 10.9645 18.098 10.125 17.0625 10.125H13.875V6.93754C13.875 5.90201 13.0355 5.06254 12 5.06254C10.9644 5.06254 10.125 5.90201 10.125 6.93754V10.125H6.93749C5.90196 10.125 5.0625 10.9645 5.0625 12C5.0625 13.0356 5.90196 13.875 6.93749 13.875H10.125V17.0625C10.125 18.098 10.9644 18.9375 12 18.9375C13.0355 18.9375 13.875 18.098 13.875 17.0625V13.875H17.0625C18.098 13.875 18.9375 13.0356 18.9375 12Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.7209 21.3724C14.215 24.6118 7.89818 24.2056 3.84641 20.1538C-0.656811 15.6506 -0.656811 8.34946 3.84641 3.84624C8.34963 -0.656979 15.6508 -0.656979 20.154 3.84624C24.2058 7.89801 24.612 14.2149 21.3726 18.7208",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4029_1689",
    x1: 12,
    y1: 23.5311,
    x2: 12,
    y2: 0.468697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9901"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a204b955bb711b800e639bf8d392026e.svg";
export { ForwardRef as ReactComponent };